import script from "./CartCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartCard.vue?vue&type=script&setup=true&lang=ts"

import "./CartCard.vue?vue&type=style&index=0&id=6045a7ab&lang=scss"

const __exports__ = script;

export default __exports__